import Api from '../library/Api';
import {
	ACHIEVEMENTS_URL,
	IMAGE_URL,
	LINKS_URL,
	PHTOTS_URL,
	SOCIAL_MEDIA_URL,
	UPDATE_PROFILE_URL,
	USER_DETAILS_URL,
	EXCISTENCE_URL,
} from './Urls';

export const fetchUserInfo = data =>
	Api.request({
		method: 'get',
		url: USER_DETAILS_URL,
		data,
	});

export const getExistence = data =>
	Api.request({
		method: 'get',
		url: EXCISTENCE_URL,
		data,
	});

export const updateProfileApi = data =>
	Api.request({
		method: 'put',
		url: UPDATE_PROFILE_URL,
		body: data,
	});

export const addSocailMediaApi = data =>
	Api.request({
		method: 'post',
		url: SOCIAL_MEDIA_URL,
		body: data,
	});

export const deleteSocailMediaApi = id =>
	Api.request({
		method: 'delete',
		url: SOCIAL_MEDIA_URL + `/${id}`,
	});

export const deleteLinkApi = id =>
	Api.request({
		method: 'delete',
		url: LINKS_URL + `/${id}`,
	});

export const deleteAchieveApi = id =>
	Api.request({
		method: 'delete',
		url: ACHIEVEMENTS_URL + `/${id}`,
	});

export const deletePhotoApi = id =>
	Api.request({
		method: 'delete',
		url: PHTOTS_URL + `/${id}`,
	});

export const addAchievementsApi = data =>
	Api.request({
		method: 'post',
		url: ACHIEVEMENTS_URL,
		body: data,
	});

export const addPhotosApi = data =>
	Api.request({
		method: 'post',
		url: PHTOTS_URL,
		body: data,
	});

export const addLinksApi = data =>
	Api.request({
		method: 'post',
		url: LINKS_URL,
		body: data,
	});

export const imgUploadApi = data =>
	Api.request({
		method: 'post',
		url: IMAGE_URL,
		body: data,
		headers: {
			Accept: 'application/json',
			Authorization: 'Client-ID d24174af5b0b95d',
		},
	});

export const imgDeleteApi = hash =>
	Api.request({
		method: 'delete',
		url: IMAGE_URL + `/${hash}`,
		headers: {
			Accept: 'application/json',
			Authorization: 'Client-ID d24174af5b0b95d',
		},
	});
